import { gql, graphql } from "react-apollo"
import { GetSlidesQuery } from "./withSlides"
import type { SlideFormViewProps, PositionInput } from "../types"

const MUTATE_REORDER_SLIDES = gql`
  mutation ReorderSlides($attractLoopId: ID!, $positions: PositionListInput!) {
    reorderSlides(attractLoopId: $attractLoopId, slidePositions: $positions) {
      id
      title
      position
    }
  }
`

const mutateReorderSlides = graphql(MUTATE_REORDER_SLIDES, {
  name: "mutateReorderSlides",
  options: ({ attractLoopId }: SlideFormViewProps) => ({
    refetchQueries: [{ query: GetSlidesQuery, variables: { attractLoopId } }]
  }),
  props: ({ mutateReorderSlides }) => ({
    reorderSlides: (
      attractLoopId: string,
      positions: { positions: Array<PositionInput> }
    ) =>
      mutateReorderSlides({
        variables: { attractLoopId, positions }
      })
  })
})

export default mutateReorderSlides



// WEBPACK FOOTER //
// ./src/Slides/queries/mutateReorderSlides.js